<template>
    <div class="table-responsive">
                <table class="table" ref="loadTable">
                    <thead>
                        <tr>
                            <th>
                            </th>
                            <th v-for="(header, h) in headers || []"
                                    :key="'h-' + h">
                                    {{header instanceof Object ? header['name'] : header }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <slot :table-data="tableData" :atribute-colapse="atributeColapse" :headers-colapse="headersColapse" :headers="headers" >
                            <template v-for="(tableRow, i) in tableData" >
                                <tr
                                    :key="'r-' + i"
                                >
                                     <td
                                        class="accordion-toggle collapsed"
                                        :id="`accordion${i}`"
                                        data-toggle="collapse"
                                        :data-parent="`#accordion${i}`"
                                        :href="`#collapse-${i}`"
                                    >
                                        <button class="btn btn-sm btn-danger "
                                            type="button"
                                        >
                                            <i class="mr-1 fas fa-arrow-down"></i>
                                        </button>
                                    </td>
                                    <td
                                        v-for="(header, h) in headers || []"
                                        :key="'v-' + h"
                                        :is="header instanceof Object && header['component'] ? header['component'] : 'generic-cell'"
                                        :data="tableRow"
                                        :value="tableRow[header instanceof Object ? header['attribute'] : header] || ''"
                                        :table="tableData"
                                        :index="i"
                                    >
                                    </td>
                                </tr>
                                <tr
                                    :id="`collapse-${i}`"
                                    class="hide-table-padding collapse in p-3"
                                    :key="'colapse-' + i"
                                >
                                    <td></td>
                                    <td :colspan="(headers || []).length - 1">
                                        <div class="row" v-if="atributeColapse">
                                            <div class="col-12">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                v-for="(headerColapse, c) in headersColapse || []"
                                                                :key="'h-colapse-' + c"
                                                            >
                                                                    {{headerColapse instanceof Object ? headerColapse['name'] : headerColapse }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="(tableRowColapse , c) in tableRow[atributeColapse] || []"
                                                            :key="'r-colapse-' + c"
                                                        >
                                                            <td
                                                                v-for="(headerColapse, h) in headersColapse || []"
                                                                :key="'v-colapse-' + h"
                                                                :is="headerColapse instanceof Object && headerColapse['component'] ? headerColapse['component'] : 'generic-cell' "
                                                                :data=" tableRowColapse"
                                                                :value="
                                                                    tableRowColapse [
                                                                        headerColapse instanceof Object
                                                                        ? headerColapse['attribute']
                                                                        : headerColapse
                                                                    ]
                                                                    || ''"
                                                                :table="tableRow[atributeColapse]"
                                                                :index="c"
                                                            >
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </slot>
                    </tbody>
                </table>
            </div>
</template>

<script>
import Axios from 'axios';
export default {
    props: [
        'ruta',
        'atributeColapse',
        'headersColapse',
        'headers'
    ],
    components:{
        'generic-cell': Vue.component("generic-cell", {
            props: ['value', 'data'],
            template: "<td> {{value}} </td>"
        })
    },
    data () {
        return {
            tableData : [],
        }
    },
    methods: {
        getData () {
            axios.get(this.ruta)
            .then(resp => {
                if (resp.data instanceof Object && Array.isArray(resp.data.data) && resp.data.data.length ) {
                    this.tableData = resp.data.data
                }
            })
            .catch( e => {
                console.log(e)
            })
        },
        refresh () {
            this.getData ()
        },
    },
    mounted () {
        this.getData()
    },
    watch: {


    }
}
</script>

